import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HttpClientModule } from '@angular/common/http';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { ApolloModule } from 'apollo-angular';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { CreateComponent } from './pages/create/create.component';
import { MenuComponent } from './pages/menu/menu.component';

import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';

import { AuthService } from './services/auth.service';
import { GraphqlService } from './services/graphql.service';

import { FormFieldComponent } from './components/form-field/form-field.component';

import { MockMenuService } from './services/mock-menu.service';
import { MenuItemsService } from './services/menu-items.service';
import { LunchItemComponent } from './components/lunch-item/lunch-item.component';
import { SearchPipe } from './pipes/search.pipe';
import { OrderComponent } from './pages/order/order.component';
import { OrderService } from './services/order.service';
import { OrderdateService } from './services/orderdate.service';
import { FormService } from './services/form.service';
import { OrderlstComponent } from './pages/orderlst/orderlst.component';
import { ItemCreateComponent } from './pages/item-create/item-create.component';
import { PagerService } from './services/pager-service';
import { OrderPlacementComponent } from './pages/order-placement/order-placement.component';

import { AppsyncService } from './services/appsync.service';

import { LoaderComponent } from './pages/loader/loader.component';
import { SignInComponent } from './pages/user/sign-in/sign-in.component';
import { SignUpComponent } from './pages/user/sign-up/sign-up.component';
import { UserComponent } from './pages/user/user.component';

import { UserService } from './services/user.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TodayOrderListComponent } from './pages/today-order-list/today-order-list.component';
import { UserOrderListComponent } from './pages/user-order-list/user-order-list.component';
// import { AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';
import { CognitoAuthService } from './services/cognitoAuth.service';
import { ItonicsAuthService } from './services/itonicsAuth.service';
import { SettingService } from './services/setting.service';

import { LoaderService } from './pages/loader/loader.service';

import { MyDatePickerModule } from 'mydatepicker';
import { MatAutocompleteModule, MatInputModule } from '@angular/material';
import { AuthorizeComponent } from './pages/user/sign-in/authorize.component';
import { LogoutComponent } from './pages/user/sign-in/logout.component';
import { CalendarFilterComponent } from './pages/calendar-filter/calendar-filter.component';
import { UserListComponent } from './pages/user/user-list.component';

import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { CountdownTimerModule } from 'ngx-countdown-timer';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SettingComponent } from './pages/setting/setting.component';
import { SettingFormComponent } from './components/setting-form/setting-form.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    FormFieldComponent,
    CreateComponent,
    MenuComponent,
    LunchItemComponent,
    SearchPipe,
    OrderComponent,
    OrderlstComponent,
    ItemCreateComponent,
    OrderPlacementComponent,
    SignInComponent,
    SignUpComponent,
    AuthorizeComponent,
    LogoutComponent,
    UserComponent,
    TodayOrderListComponent,
    LoaderComponent,
    UserOrderListComponent,
    UserListComponent,
    UserOrderListComponent,
    CalendarFilterComponent,
    SettingComponent,
    SettingFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule, // provides HttpClient for HttpLink
    ApolloModule,
    FormsModule,
    HttpLinkModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    // AmplifyAngularModule,
    MyDatePickerModule,
    MatInputModule,
    MatAutocompleteModule,
    NgxSmartModalModule.forRoot(),
    Ng2SearchPipeModule,
    Ng2OrderModule,
    NgxPaginationModule,
    CountdownTimerModule.forRoot(),
    InfiniteScrollModule
  ],
  providers: [
    AuthService,
    AuthGuard,
    AdminGuard,
    GraphqlService,
    MockMenuService,
    OrderService,
    OrderdateService,
    FormService,
    MenuItemsService,
    PagerService,
    UserService,
    CognitoAuthService,
    ItonicsAuthService,
    AppsyncService,
    // AmplifyService,
    LoaderService,
    NgxSmartModalService,
    SettingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  //  private graphQLUrl: string = environment.backend_url + '/graphql';

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts